import { cn } from '@worldcoo/ui/lib/utils';
import { motion } from 'motion/react';
import type { ReactNode } from 'react';

export function Animate(props: { children: ReactNode; translateY?: number; className?: string }) {
	return (
		<motion.div
			initial={{ opacity: 0, translateY: props.translateY ?? 0 }}
			animate={{ opacity: 1, translateY: 0 }}
			className={cn('flex flex-col gap-6', props.className)}
		>
			{props.children}
		</motion.div>
	);
}
